import { call, put, takeLatest } from "redux-saga/effects";
import { SPSELECTS } from "../../InterfacesTypes/enums";
import { spGet } from "../../utils/SharepointAPI";
import { getEnvironment } from "../../utils/utils";
import {
  fetchFailure,
  fetchQuickLinks,
  fetchStart,
  fetchSuccess,
} from "../Reducers/QuickLinksReducer";
import type { IQuickLinksSharepoint } from "../../InterfacesTypes/interfaces";
import type { SagaIterator } from "redux-saga";

const env = getEnvironment();

function* getQuickLinksWorker(): SagaIterator {
  try {
    yield put(fetchStart());

    const quickLinksListUrl = `${env.listapi}/GetByTitle('QuickLinks')/Items?$top=5000&$select=${SPSELECTS.QUICKLINKS}`;

    const res: any = yield call(spGet, quickLinksListUrl);
    const data: IQuickLinksSharepoint[] = Array.isArray(res)
      ? res
      : res?.value ?? res?.d?.results ?? [];

    yield put(fetchSuccess(data));
  } catch (err: any) {
    console.error("getQuickLinksWorker error:", err);
    yield put(
      fetchFailure(
        err?.response?.data?.error?.message || err?.message || "Något gick fel"
      )
    );
  }
}

export function* quickLinksSaga(): SagaIterator {
  yield takeLatest(fetchQuickLinks.type, getQuickLinksWorker);
}
